import { usePlan } from '~/app/plan-context'
import { useActiveProfileId } from '~/entities/profile/model/use-profiles'
import { useCancelSubscription } from '~/entities/subscription/model/use-stripe'
import { managedPlanProfileId } from '~/entities/subscription/plans'
import * as m from '~/paraglide/messages'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '~/shared/ui/alert-dialog'

interface CancelSubscriptionDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  businessId: string | undefined
}

export function CancelSubscriptionDialog({
  open,
  onOpenChange,
  businessId,
}: CancelSubscriptionDialogProps) {
  const { ownPlan } = usePlan()
  const profileId = managedPlanProfileId(useActiveProfileId(businessId), ownPlan)
  const cancelSubscription = useCancelSubscription(businessId, profileId)

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{m.cancelSubscriptionConfirmTitle()}</AlertDialogTitle>
          <AlertDialogDescription>
            {m.cancelSubscriptionConfirmDescription()}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{m.cancel()}</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => cancelSubscription.mutate()}
            className="bg-destructive text-white hover:bg-destructive/90"
          >
            {m.cancelSubscription()}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
